import { actionTypes } from 'actions/actionTypes'
import type { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const setPayPalNonce: CheckoutActionCreator = (nonce) => ({
  type: actionTypes.PAYMENT_SET_PAYPAL_NONCE,
  nonce,
})
